import { useMemo, useState } from 'react';
export function useAsyncCallState() {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    return useMemo(() => ({
        isLoading,
        setIsLoading,
        error,
        setError,
        data,
        setData,
    }), [isLoading, error, data]);
}
